/**
 * Lightweight analytics helpers for GRE vocabulary revision flows.
 * Uses gtag when available and always dispatches a DOM CustomEvent.
 */

const trackVocabEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {
    // never block UX on analytics
  }

  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent(eventName, {
          detail: params,
        })
      );
    }
  } catch {
    // ignore
  }
};

export const trackVocabHistoryOpened = (extra = {}) => {
  trackVocabEvent('vocab_history_opened', extra);
};

export const trackVocabArticleReread = (extra = {}) => {
  trackVocabEvent('vocab_article_reread', {
    source: 'history',
    ...extra,
  });
};

export const trackVocabRevisionExercisesStarted = (extra = {}) => {
  trackVocabEvent('vocab_article_revision_exercises_started', {
    source: 'history',
    ...extra,
  });
};

export const trackVocabRevisionCompleted = (extra = {}) => {
  trackVocabEvent('vocab_article_revision_completed', {
    source: 'history',
    ...extra,
  });
};
